import React from 'react'
import { AutoSizer } from 'react-virtualized'

// Components
import LinksFilter from './links-filter'
import LinksList from './links-list'
import QueueStatus from './header/queue-status'
import TotalPages from './header/total-pages'
import WarmProgress from './header/warm-progress'

import Timeline from './timeline'


const TAB_LINKS_HEIGHT = 34
const TAB_CONTENT_BORDER_SIZE = 1


const Links = () => {
  return (
    <div className="queue">
      <div className="queue-info-header">
        <div className="header-box row">
          <div className="header-box-item col-4">
            <TotalPages />
          </div>
          <div className="header-box-item col-4">
            <WarmProgress />
          </div>
          <div className="header-box-item col-4">
            <QueueStatus />
          </div>
        </div>
      </div>

      <div className="links-filter-wrapper">
        <LinksFilter />
      </div>

      <div className="links-tabs-wrapper">
        <AutoSizer>
          { ({ width, height }) => (
            <div
              className="links-tabs"
              style={ { width: `${width}px`, height: `${height}px` } }>

              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item col-6">
                  <a
                    href="#pages" className="nav-link active" role="tab"
                    data-toggle="tab">Pages</a>
                </li>
                <li className="nav-item col-6">
                  <a
                    href="#timeline" className="nav-link" role="tab"
                    data-toggle="tab">Timeline</a>
                </li>
              </ul>

              <div className="tab-content">
                <div id="pages" className="tab-pane active">
                  <div className="links-wrapper">
                    <LinksList
                      width={ width - TAB_CONTENT_BORDER_SIZE * 2 }
                      height={ height - TAB_LINKS_HEIGHT }
                    />
                  </div>
                </div>

                <div id="timeline" className="tab-pane">
                  <Timeline />
                </div>
              </div>
            </div>
          ) }
        </AutoSizer>

      </div>

    </div>
  )
}

export default Links



// WEBPACK FOOTER //
// ./src/components/links/links.js